<header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom rounded-top-1">
  <i class="me-2 fa-solid fa-user" aria-hidden="true"></i>
  <h6 class="m-0">Изтриване на профила</h6>
</header>
<ul class="m-0 list-unstyled">
  <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
        <span class="fw-medium text-danger">
          <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
          <span class="ms-2">Изтриване на профила</span>
        </span>
    <button class="btn btn-sm btn-danger flex-shrink-0"
            (click)="onOpenDeleteProfileModal()">
      <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
      <span class="ms-2">Изтрий</span>
    </button>
  </li>
</ul>
